module.exports = __webpack_public_path__ + "img/3-283x400.df759a8c.jpg";